export const BANNERS_SECTION_TYPE = "carousel";

export const DEFAULT_DESKTOP_HEIGHT = 276;
export const DEFAULT_MOBILE_HEIGHT = 220;
